import { Marker } from '@react-google-maps/api';
import miniMarkerIcon from 'assets/img/mini-marker.png';
import pausedMarkerIcon from 'assets/img/mini-marker-gray.png';
import React from 'react';
import { ECampaignStatus } from 'types/campaign';

import { useMapInfoContext } from 'components/DataMap/MapInfoProvider';

import { stringifyEventSiteAddressObject } from 'utils/lib';

// const eventMarkerAvailableIcon = eventMarkerBlueIcon;
// const eventMarkerUnavailableIcon = eventMarkerGrayIcon;
// const eventMarkerSelectedIcon = eventMarkerGreenIcon;

const miniMarkerWidth = 11;
const miniMarkerHeight = 12;

const eventMarkerAvailableIcon = miniMarkerIcon;
const eventMarkerUnavailableIcon = miniMarkerIcon;
const eventMarkerSelectedIcon = miniMarkerIcon;
const eventMarkerPausedIcon = pausedMarkerIcon;

const zoomThresholdToShowEventDataMarkers = 15;
const markerBaseAnchor = 7.5;
const minScaledZoom = 15;
const maxScaledZoom = 18;
const minMarkerScale = 1;
const maxMarkerScale = 3;
const isPausedCampaignMarker = (eventData) => eventData.campaignStatus === ECampaignStatus.Paused;

const markerIconOptions = (markerIcon, zoom = minScaledZoom, selected = false) => {
  const normalizedZoom = Math.min(Math.max(zoom, minScaledZoom), maxScaledZoom);
  const zoomProgress = (normalizedZoom - minScaledZoom) / (maxScaledZoom - minScaledZoom);
  const markerScale = (minMarkerScale + (zoomProgress * (maxMarkerScale - minMarkerScale))) * (selected ? 1.2 : 1);

  return {
    url: markerIcon,
    scaledSize: {
      width: miniMarkerWidth * markerScale,
      height: miniMarkerHeight * markerScale,
    },
    anchor: new window.google.maps.Point(markerBaseAnchor * markerScale, markerBaseAnchor * markerScale),
  };
};

const EventMarkers = ({
  eventData, highlightEventDataApns, ignoreZoomThresholdCulling, onEventDataSelect, selectedEventDataId,
}) => {
  const { mapInstance, mapBounds } = useMapInfoContext();

  const [markersToRender, setMarkersToRender] = React.useState([]);
  const highlightedApnsSet = React.useMemo(() => new Set((highlightEventDataApns || []).map((item) => (typeof item === 'string' ? item : item.apn))), [highlightEventDataApns]);

  React.useEffect(() => {
    if (!eventData || !mapInstance) return;

    const arr = [];

    eventData.forEach((o) => {
      const {
        _id, apn, siteLocation, available,
      } = o;

      if (!mapInstance || !mapInstance.getBounds() || !mapInstance.getBounds().contains(new window.google.maps.LatLng(siteLocation.coordinates[1], siteLocation.coordinates[0]))) return;

      let markerIcon;

      if (isPausedCampaignMarker(o)) {
        markerIcon = eventMarkerPausedIcon;
      } else if (!available) {
        markerIcon = eventMarkerUnavailableIcon;
      } else if (highlightedApnsSet.has(apn)) {
        markerIcon = eventMarkerSelectedIcon;
      } else {
        markerIcon = eventMarkerAvailableIcon;
      }

      const position = { lat: siteLocation.coordinates[1], lng: siteLocation.coordinates[0] };
      const isSelected = selectedEventDataId != null && String(_id) === String(selectedEventDataId);
      const siteAddress = stringifyEventSiteAddressObject(o.siteAddress);

      arr.push((
        <Marker
          key={_id}
          position={position}
          icon={markerIconOptions(markerIcon, mapInstance.zoom, isSelected)}
          title={onEventDataSelect ? `View details${siteAddress ? ` for ${siteAddress}` : ''}` : undefined}
          zIndex={onEventDataSelect ? (isSelected ? 1100 : 1000) : undefined}
          onClick={onEventDataSelect ? () => onEventDataSelect(o) : undefined}
        />
      ));
    });

    setMarkersToRender(arr);
  }, [eventData, mapBounds, highlightedApnsSet, mapInstance, onEventDataSelect, selectedEventDataId]);

  if (!ignoreZoomThresholdCulling && mapInstance?.zoom < zoomThresholdToShowEventDataMarkers) {
    return null;
  }

  return (
    <>
      {markersToRender}
    </>
  );
};

export default EventMarkers;
